import * as _ from 'underscore';

import {FeedbackObject} from '../../interfaces'

const subStrings = [
  ' ,',
  ' .',
  ' ;',
  ' !',
  ' ?'
];

const subStringsToText = {
  ' ,': 'a comma',
  ' .': 'a period',
  ' ;': 'a semi-colon',
  ' !': 'an exclamation mark',
  ' ?': 'a question mark',
};

export function getFeedbackForPunc(punc: string):string {
  const fb = subStringsToText[punc];
  return `<p>Revise your sentence. You don't need to have a space before ${fb}.</p>`;
}

export function checkForSpacingError(userString: string):string {
  // Strip ellipses (U+2026, 3+ consecutive periods, or spaced "." sequences like
  // ". . .") so a leading space before an ellipsis doesn't trip the " ." check.
  const cleaned = userString.replace(/…|\.(?:\s*\.){2,}/g, '');
  return _.find(subStrings, subString => cleaned.indexOf(subString) !== -1);
}

export function spacingBeforePunctuation(userString: string):FeedbackObject|undefined {
  const match = checkForSpacingError(userString);
  return (match ? { feedback: getFeedbackForPunc(match), } : undefined);
}
